<template>
  <article class="card js-card filtered-item">
    <div class="cursor-pointer" 
      :class="{'card__img-holder card__img-holderTs picturefill-background': brandName === Brand.Travelsphere, 'card__img-holder picturefill-background' : brandName !== Brand.Travelsphere}"
      @click="handleExploreClick">
      <picture>
        <source :srcset="`${item.image.smallUrl}?format=webp`" media="(max-width: 575px)" type="image/webp">
        <source :srcset="`${item.image.mediumUrl}?format=webp`" media="(min-width: 576px)" type="image/webp">
        <img :src="`${item.image.smallUrl}?format=webp`" :alt="item.name" loading="lazy">
      </picture>

      <div v-if="item.tourSummary.offerText" class="offer-tag">
        {{ item.tourSummary.offerText }}
      </div>
    </div>
    <div class="card__content" :class="{'card__contentTs': brandName === Brand.Travelsphere}">
      <div class="card__inner">
        <div class="card__header">
          <span
            class="card__subtitle"
            :class="{'cardSubtitleTs': brandName === Brand.Travelsphere}"
            v-html="item.departureDatesFormatted"
          ></span>

          <h3 class="card__title">
            <a 
            :class="{'cardTitleTs': brandName === Brand.Travelsphere}"
            :href="item.tourLink.url" 
            target="_blank"
            @click="handleExploreClick"
            >{{ item.name }}</a>
          </h3>
        </div>

        <div v-if="brandName !== Brand.Travelsphere" class="tour-price">
          <strong class="tour-price__days">
            {{ item.tourSummary.fromDays }}
            days from
          </strong>

          <span class="tour-price__value">
            {{ item.tourSummary.fromPriceFormatted }}
          </span>

          <span
            v-if="item.tourSummary.wasFromPrice > 0"
            class="tour-price__was-value"
          >
            was
            <strong>{{ item.tourSummary.wasPriceFormatted }}</strong>
          </span>
        </div>

        <div v-if="item.description" class="card__description">
          <p v-html="item.description"></p>
        </div>

        <div v-if="brandName === Brand.Travelsphere" class="tour-price" :class="{'tour-priceTs': brandName === Brand.Travelsphere}">
          <span class="tour-price__days">
            {{ item.tourSummary.fromDays }}
            days from
          </span>

          <strong class="tour-price__value">
            {{ item.tourSummary.fromPriceFormatted }}
          </strong>

          <span
            v-if="item.tourSummary.wasFromPrice > 0"
            class="tour-price__was-value"
          >
            was
            <span>{{ item.tourSummary.wasPriceFormatted }}</span>
          </span>
        </div>
      </div>

      <div class="card__footer card__footer_sm filter-buttons">
        <a
          v-if="item.mapLink"
          :href="item.mapLink.url"
          class="btn js-modal filter-buttons-width btn--outline-gray-color_sm"
          :class="{
            'btn--outline-gray-color resultCardMapTs': brandName === Brand.Travelsphere,
            'btn-tertiary': brandName !== Brand.Travelsphere
          }"
          >{{ item.mapLink.name }}</a
        >
        <a target="_blank" 
         class="btn card__btn filter-buttons-width"
         :class="{'resultCardTs': brandName === Brand.Travelsphere}"
         :href="item.tourLink.url"
         @click="handleExploreClick">{{
          item.tourLink.name
        }}</a>
      </div>
    </div>
  </article>
</template>

<script>
import WishlistToggle from "./Wishlist/WishlistToggle.vue";
import {Brand} from '../../brand.js';

export default {
  name: "FilterIndexItem",
  props: ["item", "readMoreText", "wishlistCookieName","brandName"],

  components: {
    WishlistToggle,
  },

  data() {
    return {
      Brand
    };
  },

  methods: {
    handleExploreClick(e) {
      e.preventDefault();
      try {
        var dataLayerItem = JSON.parse(JSON.stringify({
          items: [{
            item_id: this.item.tourCode,
            item_name: this.item.name
          }]
        }));
        GTM.event('select_item', dataLayerItem);
      } catch(e) { 
        console.error(e);
      }
      
      window.open(this.item.tourLink.url, '_blank');
    },
  },

  filters: {
    truncate(text, length, suffix) {
      return text.substring(0, length) + suffix;
    },
  },

  mounted() {
    this.$nextTick().then(() => {
      picturefillBackground();
    });
  },
};
</script>